import { useEffect, useMemo, useState } from "react";
import { useMarketplaceContract, usePunkContract } from "hooks/useContract";
import { sellNFT } from "utils/sellNFT";
import { ethers } from "ethers";
import { toast } from "react-toastify";
import useAuth from "hooks/useAuth";
import { emptyPunk } from "config/basePunks";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import {
  Button,
  Container,
  Mask,
  Perspective,
  StyledHero,
} from "../components/Styled";
import PunkCard from "components/PunkCard";
import Menu from "components/Menu";
import SocialNetworks from "components/SocialNetworks";
import background from "../images/background.jpg";
import ReactLoading from "react-loading";

const NFTDetail = () => {
  const { id } = useParams();
  const history = useHistory();
  const { account } = useAuth();
  const [price, setPrice] = useState();
  const [allowance, setAllowance] = useState(null);
  const [locked, setLocked] = useState(false);

  const contract = usePunkContract();
  const marketplace = useMarketplaceContract();
  const [needEdit, setNeedEdit] = useState(false);
  const [needSell, setNeedSell] = useState(false);
  const [punk, setPunk] = useState(emptyPunk);
  const [refetch, setRefetch] = useState(null);
  if (isNaN(Number(id))) history.push("/");
  useEffect(() => {
    let p = null;

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/punks/${id}.json`)
      .then((result) => result.data)
      .then((punk) => {
        p = punk;

        return marketplace.viewAsksByCollectionAndTokenIds(contract.address, [
          id,
        ]);
      })
      .then((resolve) => {
        console.log("resolve", resolve);
        p.lastPrices = resolve.lastPrices;
        if (!resolve.statuses[0]) {
          p.onSale = false;
          p.rarity = p.rank;
          contract.ownerOf(id).then((owner) => {
            p.owner = owner;
            setPunk(p);
          });
        } else {
          p.info = resolve.askInfo[0];
          p.onSale = true;
          p.owner = resolve.askInfo[0].seller;
          setPunk(p);
        }
      })
      .catch(() => history.push("/"));
    // eslint-disable-next-line
  }, [account, history, id, refetch]);

  useEffect(() => {
    if (punk.id)
      contract.getApproved(punk.id).then((allowance) => {
        setAllowance(allowance);
      });
    // eslint-disable-next-line
  }, [punk]);

  const isMyToken = useMemo(() => {
    if (punk?.owner) return punk.owner === account;
    return false;
    // eslint-disable-next-line
  }, [punk]);

  const refetchNFT = () => {
    setRefetch(new Date().getTime());
  };

  if (punk.id === null)
    return (
      <ReactLoading
        type="spin"
        color={"#fff"}
        height={"100"}
        width={"100"}
        style={{
          top: "50%",
          left: "50%",
          position: "absolute",
          transform: "translate(-50%,-50%)",
        }}
      />
    );
  return (
    <div className="bg-primary text-white font-main tracking-wider">
      <StyledHero className="hero flex flex-col justify-center">
        <Menu />
        <Container className="content">
          <div className="flex justify-center p-5 md:p-20 flex-wrap">
            <div className="flex-col flex justify-center pr-8 max-w-md text-center mb-6 sm:mb-12 pr-20">
              <ul className="text-left">
                <li>Status: {punk.onSale ? "On sale" : "Not listed"}</li>
                <li>
                  Owner:{" "}
                  {isMyToken ? (
                    "You"
                  ) : (
                    <a
                      href={`${process.env.REACT_APP_BLOCK_EXPLORER}/address/${punk.owner}`}
                    >
                      {" "}
                      0x**
                      {punk.owner.slice(
                        punk.owner.length - 4,
                        punk.owner.length
                      )}
                    </a>
                  )}
                </li>

                {punk.onSale && (
                  <li>
                    Price:{" "}
                    {ethers.utils
                      .formatEther(punk.info.price.toString())
                      .toString()}{" "}
                    ETH
                  </li>
                )}
                <li>
                  Last sales:{" "}
                  {punk.lastPrices?.length === 1 &&
                    punk.lastPrices[0].eq(ethers.BigNumber.from(0)) &&
                    "No sales"}
                  <ul>
                    {punk.lastPrices?.filter(lastPrice => !lastPrice.eq(ethers.BigNumber.from(0))).map((lastPrice) => {
                      return (
                        <li>
                          -{" "}
                          {ethers.utils
                            .formatEther(lastPrice.toString())
                            .toString()}{" "}
                          ETH
                        </li>
                      );
                    })}
                  </ul>
                </li>
              </ul>
              <span className="block w-full border-b border-solid border-white mb-4 mt-4"></span>

              {!isMyToken && punk.onSale && (
                <Button
                  onClick={() => {
                    if (locked) return;

                    marketplace
                      .buyToken(contract.address, punk.id, {
                        value: punk.info.price.toString(),
                      })
                      .then((resolve) => resolve.wait())
                      .then((punk) => {
                        setLocked(false);
                        refetchNFT();
                        toast.success(
                          "Congratulation ! This punk is now your own"
                        );
                      })
                      .catch(() => {
                        toast.error("An error has occured");
                        setLocked(false);
                      });
                  }}
                  className="mx-auto block mt-8"
                >
                  Buy
                </Button>
              )}
              {isMyToken && (
                <div>
                  {!punk.onSale && !needSell && (
                    <Button
                      onClick={() => {
                        setNeedSell(true);
                      }}
                      className="mx-auto block mt-8"
                    >
                      Sell
                    </Button>
                  )}

                  {((!punk.onSale && needSell) || needEdit) && (
                    <div className="mt-8 flex">
                      {allowance !== null &&
                        Number(allowance) === 0 &&
                        needSell && (
                          <div className="flex">
                            <Button
                              type="submit"
                              className="mx-auto block mr-2"
                              onClick={() => {
                                if (locked) return;
                                setLocked(true);
                                contract
                                  .approve(marketplace.address, punk.id)
                                  .then((resolve) => resolve.wait())
                                  .then((allowance) => {
                                    setAllowance(allowance);
                                    setLocked(false);
                                  })
                                  .catch(() => setLocked(false));
                              }}
                            >
                              Approve
                            </Button>
                            <Button
                              style={{ marginLeft: "0.5rem" }}
                              onClick={() => {
                                setNeedEdit(false);
                                setNeedSell(false);
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
                        )}
                      {((allowance !== null && Number(allowance) !== 0) ||
                        needEdit) && (
                        <div>
                          <p className="mb-8 block">Enter price in ETH</p>
                          <label className="block relative">
                            <input
                              className="border-gray-200 border border-solid rounded-md block w-full p-2 text-black"
                              value={price}
                              defaultValue={
                                needEdit
                                  ? ethers.utils
                                      .formatEther(punk.info.price.toString())
                                      .toString()
                                  : null
                              }
                              placeholder={"1.0"}
                              name="price"
                              type="text"
                              onChange={({ target }) => {
                                const formated = target.value
                                  .replace(" ", "")
                                  .replace(",", ".")
                                  .replace(/[^0-9.]/, "");
                                setPrice(formated);
                              }}
                            />
                            <span
                              className="absolute pr-2 text-black"
                              style={{
                                top: "50%",
                                right: "0",
                                transform: "translate(0,-50%)",
                              }}
                            >
                              ETH
                            </span>
                          </label>
                          <div className="flex mt-8">
                            {needSell && (
                              <Button
                                style={{ marginRight: "0.5rem" }}
                                onClick={() => {
                                  if (locked) return;
                                  setLocked(true);
                                  const finalPrice = Number(price);
                                  if (isNaN(finalPrice) || finalPrice === 0) {
                                    toast.error("Please enter an valid price");
                                    setLocked(false);
                                    return;
                                  }
                                  sellNFT(
                                    contract,
                                    marketplace,
                                    punk.id,
                                    ethers.utils.parseEther(price)
                                  )
                                    .then((resolve) => {
                                      toast.success(
                                        "Your punk is now in the marketplace"
                                      );
                                      refetchNFT();
                                      setNeedSell(false);
                                      setLocked(false);
                                    })
                                    .catch(() => {
                                      setLocked(false);
                                    });
                                }}
                                className="mx-auto block"
                              >
                                List it
                              </Button>
                            )}
                            {needEdit && (
                              <Button
                                style={{ marginRight: "0.5rem" }}
                                onClick={() => {
                                  if (locked) return;
                                  setLocked(true);
                                  const finalPrice = Number(price);
                                  if (isNaN(finalPrice) || finalPrice === 0) {
                                    toast.error("Please enter an valid price");
                                    setLocked(false);
                                    return;
                                  }

                                  marketplace
                                    .modifyAskOrder(
                                      contract.address,
                                      punk.id,
                                      ethers.utils.parseEther(price)
                                    )
                                    .then((resolve) => resolve.wait())
                                    .then((resolve) => {
                                      toast.success(
                                        "Your punk order is updated"
                                      );
                                      refetchNFT();
                                      setNeedEdit(false);
                                      setLocked(false);
                                    })
                                    .catch(() => {
                                      toast.error("An error has occured");
                                      setLocked(false);
                                    });
                                }}
                                className="mx-auto block"
                              >
                                Edit order
                              </Button>
                            )}
                            <Button
                              style={{ marginLeft: "0.5rem" }}
                              onClick={() => {
                                setNeedEdit(false);
                                setNeedSell(false);
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {punk.onSale && (
                    <div>
                      {isMyToken && !needEdit && (
                        <div className="flex">
                          <Button
                            style={{ marginRight: "0.5rem" }}
                            onClick={() => {
                              if (locked) return;
                              setLocked(true);
                              marketplace
                                .cancelAskOrder(contract.address, punk.id)
                                .then((resolve) => resolve.wait())
                                .then(() => {
                                  refetchNFT();
                                  setLocked(false);
                                  toast.success(
                                    "Your punk is no longer on sale."
                                  );
                                })
                                .catch(() => {
                                  toast.error("An error has occured");
                                  setLocked(false);
                                });
                            }}
                            className="mx-auto block mt-8"
                          >
                            Unlist
                          </Button>
                          <Button
                            style={{ marginLeft: "0.5rem" }}
                            onClick={() => {
                              setNeedEdit(true);
                            }}
                            className="mx-auto block mt-8"
                          >
                            Edit
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <Perspective className="punk">
              <PunkCard punk={punk} />
            </Perspective>
          </div>
        </Container>
        <div className="absolute left-0 bottom-0 w-full h-full z-10 flex">
          <img
            src={background}
            className="w-full block object-cover"
            alt="punk"
          />
        </div>
        <Mask />
        <SocialNetworks />
      </StyledHero>
    </div>
  );
};

export default NFTDetail;
